import { FC, useContext } from 'react';

import {
  Bar,
  BarChart,
  Brush,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';

import { LocalizationContext } from 'localization';
import { SettingsContext } from 'settings';

import { ETypeSlice, EVariantSlice, TNormalizedItem } from '../../types';
import { formatMoney, formatSeconds } from '../../utils';
import { CustomTooltip } from './CustomTooltip';

export interface IChartProps {
  data: Array<TNormalizedItem>;
  type: ETypeSlice;
  variant: EVariantSlice;
}
export const Chart: FC<IChartProps> = ({ data, variant, type }) => {
  const { t } = useContext(LocalizationContext);
  const {
    state: {
      settings: {
        currency: { sign: currency },
      },
    },
  } = useContext(SettingsContext);
  const dataKey = variant === EVariantSlice.PROCEEDS ? 'proceeds' : 'time';
  const xAxisKey = type === ETypeSlice.GROUPS ? 'groupTitle' : 'alias';

  return (
    <ResponsiveContainer width="100%" height="100%">
      <BarChart data={data}>
        <XAxis
          dataKey={xAxisKey}
          axisLine={false}
          tickLine={false}
          dy={8}
          fontSize={14}
          stroke="var(--text-primary)"
        />
        <XAxis
          xAxisId="group"
          dataKey="groupTitle"
          stroke="var(--text-secondary)"
          fontSize={12}
          axisLine={false}
          tickLine={false}
          tickFormatter={(value) => (type === ETypeSlice.GROUPS ? '' : value)}
        />
        <YAxis
          type="number"
          width={110}
          dx={-100}
          textAnchor="start"
          stroke="var(--text-secondary)"
          fontSize={14}
          tickFormatter={(data) =>
            variant === EVariantSlice.PROCEEDS
              ? formatMoney(data, currency)
              : formatSeconds(t, data)
          }
          tickLine={false}
          axisLine={false}
        />
        <Tooltip
          cursor={{ fill: 'var(--bg-item-secondary)' }}
          content={({ payload }) => {
            return <CustomTooltip data={payload?.[0]?.payload} />;
          }}
        />
        <Bar
          dataKey={`clients.${dataKey}`}
          stackId="a"
          fill="#2C87FD"
          radius={[0, 0, 8, 8]}
        />
        <Bar
          dataKey={`guests.${dataKey}`}
          stackId="a"
          fill="#2C87FD"
          fillOpacity="0.3"
          style={{ borderRadius: 8 }}
          radius={[8, 8, 0, 0]}
        />
        <Brush
          dataKey="alias"
          height={32}
          stroke="var(--text-disable)"
          fill="var(--bg-item-primary)"
          travellerWidth={32}
          tickFormatter={() => ''}
          traveller={(props) => (
            <svg
              {...props}
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect width="24" height="24" fill="var(--bg-item-primary)" />
              <rect
                x="8"
                y="7.5"
                width="8"
                height="1"
                fill="var(--text-primary)"
              />
              <rect
                x="8"
                y="11.5"
                width="8"
                height="1"
                fill="var(--text-primary)"
              />
              <rect
                x="8"
                y="15.5"
                width="8"
                height="1"
                fill="var(--text-primary)"
              />
            </svg>
          )}
        />
      </BarChart>
    </ResponsiveContainer>
  );
};
